// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"a4d74806","211":"09975af3","224":"4c4ab600","453":"3d395fa3","465":"6633ef45","853":"e0776d3b"}[chunkId] + ".chunk.js";
};